/* tslint:disable */
/* eslint-disable */
export enum WorkContactDuplicateMatchEnum {
  Email = 'EMAIL',
  Phone = 'PHONE',
  NameExact = 'NAME_EXACT',
  Name = 'NAME',
  CompanyExact = 'COMPANY_EXACT',
  Company = 'COMPANY',
  AddressExact = 'ADDRESS_EXACT',
  Address = 'ADDRESS'
}
